import React, { useEffect, useLayoutEffect, useState } from "react";
import { IMAGE_BASE_URL, SETTING, USER_DETAIL } from "./constants/api";
import Base from "./component/inc/Base";
import Login from "./component/auth/Login";
import { Spin } from "antd";
import { displayMessage, getAPI, postAPI } from "./utils/common";
import LS_SERVICE from "./utils/localStorage";
import { ERROR_MSG_TYPE } from "./constants/messages";
import {
  PUSHER_APP_CLUSTER,
  PUSHER_APP_KEY,
  SECONDARY_THEME,
  THEME,
} from "./constants/constent";
import Pusher from "pusher-js";
import {
  NotificationProvider,
  useNotification,
} from "./component/notification/NotificationContext";
import NotificationModal from "./component/notification/NotificationModal";

const App = () => {
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const [loading, setIsLoading] = useState(true);
  const { setNotification } = useNotification();

  useEffect(() => {
    // Initialize Pusher
    Pusher.logToConsole = true;
    const pusher = new Pusher(PUSHER_APP_KEY, {
      cluster: PUSHER_APP_CLUSTER,
      forceTLS: true,
    });

    // Subscribe to the notifications channel
    const channel = pusher.subscribe("my-channel");

    // Listen for the new notification event
    channel.bind("my-event", function (data) {
      console.log("Received notification data:", data);
      setNotification(data);
    });

    return () => {
      pusher.unsubscribe("my-channel");
    };
  }, [setNotification]);

  const getSetting = async () => {
    try {
      const successFn = (data) => {
        if (data.status === true) {
          const settings = {
            logo: data.data.company_logo.filePath || null,
            favicon: data.data.company_favicon.filePath || null,
            company_name: data.data.company_name || null,
            company_address: data.data.company_address || null,
            company_email: data.data.company_email || null,
            company_description: data.data.company_description || null,
            company_phone: data.data.company_phone || null,
            theme: data.data.theme || THEME,
          };

          LS_SERVICE.set("setting", settings);
          const { theme } = LS_SERVICE.get("setting") || {};
          document.documentElement.style.setProperty(
            "--primary-color",
            "#" + theme
          );
          document.documentElement.style.setProperty(
            "--secondary-color",
            "#" + SECONDARY_THEME
          );

          if (settings.favicon) {
            const link = document.querySelector("link[rel*='icon']");
            if (link) {
              link.href = IMAGE_BASE_URL + settings.favicon;
            } else {
              const newLink = document.createElement("link");
              newLink.rel = "icon";
              newLink.href = IMAGE_BASE_URL + settings.favicon;
              document.head.appendChild(newLink);
            }
          }

          if (settings.company_name) {
            document.title = settings.company_name;
          }

          if (settings.company_description) {
            const metaDescription = document.querySelector(
              "meta[name='description']"
            );
            if (metaDescription) {
              metaDescription.content = settings.company_description;
            } else {
              const newMetaDescription = document.createElement("meta");
              newMetaDescription.name = "description";
              newMetaDescription.content = settings.company_description;
              document.head.appendChild(newMetaDescription);
            }
          }
        } else {
          displayMessage(
            ERROR_MSG_TYPE,
            data.message || "Failed to load settings"
          );
        }
      };

      const errorFn = () => {
        displayMessage(ERROR_MSG_TYPE, "Unable to get settings");
      };

      await getAPI(SETTING, successFn, errorFn);
    } catch (error) {
      displayMessage(
        ERROR_MSG_TYPE,
        "An error occurred while loading settings."
      );
    }
  };

  const getUserData = async () => {
    const data = new FormData();
    data.append("id", LS_SERVICE.get("id"));

    const successFn = (data) => {
      if (data.status === true) {
        LS_SERVICE.set("name", data.user.name);
        LS_SERVICE.set("user_type", data.user.user_type);
        LS_SERVICE.set("phone", data.user.mobile);
        LS_SERVICE.set("email", data.user.email);
        setIsLoggedIn(true);
      } else {
        setIsLoggedIn(false);
      }
    };

    const errorFn = () => {
      setIsLoggedIn(false);
    };

    await postAPI(USER_DETAIL, data, successFn, errorFn);
  };

  useLayoutEffect(() => {
    const loadData = async () => {
      setIsLoading(true);

      await getSetting();

      if (LS_SERVICE.get("id")) {
        await getUserData();
      }

      setIsLoading(false);
    };

    loadData();
  }, []);

  if (loading) {
    return <Spin />;
  }

  return isLoggedIn ? <Base /> : <Login />;
};
// Wrap your App component with the NotificationProvider to share state globally
const WrappedApp = () => (
  <NotificationProvider>
    <App />
    <NotificationModal /> {/* Modal will display the notification */}
  </NotificationProvider>
);

export default WrappedApp;
